import { HasChildren } from "@types";
import { SnackbarProvider as NotistackProvider } from "notistack";

type Props = HasChildren;
export default function SnackbarProvider({ children }: Props) {
  return <NotistackProvider autoHideDuration={1000}>{children}</NotistackProvider>;
}
